<template>
    <el-dialog
        title="分拨"
        class="distribution"
        :visible.sync="tableVisible"
        :before-close="handleCancel"
    >
        <!-- v-if="this.rowData.customerAgingType === 'REGIONAL_AGING_DEFAULT'" -->
        <div class="textAlign">
            <otpAdvance
                @getAdvanceValue="getAdvanceValue"
                :mValue="distributionWhName"
                :params="customerWhCode"
            ></otpAdvance>
        </div>
        <el-table :data="allocateData" v-loading="tableLoading" :row-class-name="tableRowClassName">
            <el-table-column prop="distributionWhName" show-overflow-tooltip label="分拨仓"></el-table-column>
            <el-table-column prop="siteName" show-overflow-tooltip label="服务平台"></el-table-column>
            <el-table-column prop="siteCode" show-overflow-tooltip label="服务平台编码"></el-table-column>
            <el-table-column prop="eblcDetailAddress" show-overflow-tooltip label="分拨仓地址"></el-table-column>
            <el-table-column prop="cdwhContact" show-overflow-tooltip label="分拨仓联系人"></el-table-column>
        </el-table>
        <div class="dis-footer">
            <el-button @click="handleCancel">取 消</el-button>
            <el-button type="primary" :loading="sureLoading" @click="handleAllocate">确 定</el-button>
        </div>
    </el-dialog>
</template>
<script>
import { getStorageData, getAllocate, getAllocatesBatch } from '../../../../api/basePlatoon';
import otpAdvance from '@/components/lots/otpAdvance';
export default {
    components: { otpAdvance },
    props: {
        tableVisible: {
            type: Boolean,
            default: false
        },
        rowData: {
            type: Object,
            default () {
                return {};
            }
        },
        checkedSourceList: { // 批量分拨操作的数据
            type: Array,
            default () {
                return [];
            }
        },
        type: { // 1:单个分拨 2:批量分拨
            type: String,
            default () {
                return '1';
            }
        }
    },
    data () {
        return {
            allocateData: [],
            radio: false,
            tableLoading: false,
            sureLoading: false,
            checkedWarehouse: [],
            distributionWhName: '',
            customerWhCode: {
                'name': '请点击右侧按钮选择仓库',
                'advanceLabel': '仓库',
                'value': 'distributionWhName',
                'advanceConfig': [
                    { 'prop': 'cdwhName', 'value': '仓库名称' },
                    { 'prop': 'whCode', 'value': '仓库编码' },
                    { 'prop': 'siteCode', 'value': '服务平台编码' },
                    { 'prop': 'siteName', 'value': '服务平台名称' }
                ],
                'tableConfig': [
                    { 'prop': 'whCode', 'value': '仓库编码' },
                    { 'prop': 'cdwhName', 'value': '仓库名称' },
                    { 'prop': 'siteCode', 'value': '服务平台编码' },
                    { 'prop': 'siteName', 'value': '服务平台名称' },
                    { 'prop': 'whCategory', 'value': '仓库分类', type: 'select', optionsKey: 'WH_CATEGORY', options: [] }
                ],
                'advanceUrl': 'cdWarehouse/search?cdwhIsStop=0',
                'advanceCascade': 'siteCode',
                'cbParams': [
                    'whCode#distributionWhCode', 'cdwhName#distributionWhName', 'siteCode', 'siteName', 'eblcDetailAddress', 'cdwhContact'
                ]
            }
        };
    },
    methods: {
        // 基础数据弹窗，data为双击弹窗表格行返回的数据
        getAdvanceValue (data) {
            const datas = JSON.parse(JSON.stringify(data));
            data.stationList = [datas];
            data.distributionWhNames = data.distributionWhName;
            this.allocateData = [data];
            this.radio = 0;
            this.checkedWarehouse = { ...this.allocateData[0] };
        },
        tableRowClassName ({ row, rowIndex }) {
            row.index = rowIndex;
        },
        rowClick (row, column, event) {
            this.getCurrentRow(row, row.index);
        },
        handleAllocate () {
            if (this.allocateData.length === 0) {
                this.$message.warning('请选择分拨仓库');
                return;
            };
            const check = this.allocateData[0];
            if (this.type === '1') {
                // 不能分拨到同一个服务平台
                if (this.rowData.siteCode === check.siteCode) {
                    this.$message.warning('不能分拨到同一个服务平台');
                    return;
                }
                // 分拨平台与收货平台编码一致则不能分拨
                if (this.rowData.targeSiteCode === check.siteCode) {
                    this.$message.warning('分拨平台与收货平台不能一致');
                    return;
                }
                const obj = {
                    distributionWhCode: check.distributionWhCode,
                    distributionWhName: check.distributionWhName,
                    taskNo: this.rowData.taskNo,
                    trunk: true
                };
                this.getAllocates(obj);
            } else {
                // 不能分拨到同一个服务平台
                const checkList = this.checkedSourceList.filter(item => item.siteCode === check.siteCode);
                if (checkList.length) {
                    this.$message.warning('不能分拨到同一个服务平台');
                    return;
                }
                // 分拨平台与收货平台编码一致则不能分拨
                const targeSiteCodeList = this.checkedSourceList.filter(item => item.targeSiteCode === check.siteCode);
                if (targeSiteCodeList.length) {
                    this.$message.warning(`客户订单号${targeSiteCodeList.map(item => item.customerOrderNo).join(',')}分拨平台与收货平台不能一致`);
                    return;
                }
                const dataArr = [];
                this.checkedSourceList.forEach(e => {
                    const obj = {
                        'distributionWhCode': check.distributionWhCode,
                        'distributionWhName': check.distributionWhName,
                        'taskNo': e.taskNo,
                        trunk: true
                    };
                    dataArr.push(obj);
                });

                this.getAllocatesBatchs(dataArr);
            }
        },
        // 单个分拨
        getAllocates (arr) {
            this.sureLoading = true;
            getAllocate(arr).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success('分拨成功');
                    this.radio = false;
                    this.$emit('distributionOk');
                };
            }).finally(() => {
                this.sureLoading = false;
            });
        },
        // 批量分拨
        getAllocatesBatchs (obj) {
            this.sureLoading = true;
            getAllocatesBatch(obj).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success('批量分拨成功');
                    this.radio = false;
                    this.$emit('distributionOk');
                };
            }).finally(() => {
                this.sureLoading = false;
            });
        },
        handleCancel () {
            this.$emit('update:tableVisible', false);
        },
        getTableList (data) {
            // const params = { taskNo: data.taskNo, deliveryType: data.deliveryType };
            const params = { taskNo: data.taskNo };
            this.tableLoading = true;
            getStorageData(params).then(res => {
                if (res) {
                    if (!res.data || res.data.length <= 0) return this.$message.warning('无分拨仓数据，请核实是否已配置');
                    let errorMsg = '';
                    this.allocateData = res.data.map(item => {
                        // if (item.stationList && item.stationList.length > 0) {
                        //     this.$set(item, 'disabled', false);
                        //     const stationList = item.stationList.map(s => s.whName);
                        //     item.distributionWhNames = stationList.join('-');
                        // } else {
                        //     this.$set(item, 'disabled', true);
                        // }
                        if (item.stationCode) {
                            this.$set(item, 'disabled', false);
                        } else {
                            this.$set(item, 'disabled', true);
                        }
                        if (item.errorMsg && +item.isAging === 1) {
                            errorMsg += `<div style='line-height: 30px;'>
                                <span>${item.errorMsg}</span></div>`;
                        }
                        return item;
                    });
                    if (errorMsg) {
                        this.$message({
                            type: 'error',
                            duration: 5000,
                            dangerouslyUseHTMLString: true,
                            message: errorMsg,
                            showClose: true
                        });
                    }
                    if (this.allocateData.length === 1) {
                        const stationList = this.allocateData[0].stationList;
                        if (!stationList || stationList.length <= 0) {
                            this.radio = false;
                            this.checkedWarehouse = [];
                        } else {
                            this.radio = 0;
                            this.checkedWarehouse = { ...this.allocateData[0] };
                        }
                    }
                }
            }).finally(() => {
                this.tableLoading = false;
            });
        },
        getCurrentRow (data, index) {
            // if (!data.stationList || data.stationList.length <= 0) {
            //     return this.$message.error(data.errorMsg || '没有仓库编码');
            // }
            if (!data.stationCode) {
                return this.$message.error(data.errorMsg || '没有仓库编码');
            }
            this.radio = index;
            this.checkedWarehouse = { ...data };
        }
    },
    mounted () { }
};
</script>
<style lang="less">
.distribution {
    .dis-footer {
        text-align: right;
        margin-top: 15px;
    }
    .textAlign {
        width: 50%;
        margin-bottom: 10px;
    }
}
</style>
